import * as actions from "./actions";

export const WINDOW = {
  EXPERIENCE: "EXPERIENCE",
  EDUCATION: "EDUCATION",
  ABOUT_ME: "ABOUT_ME",
  LINKS: "LINKS",
  SHUTDOWN: "SHUTDOWN",
};

export { actions };
